import { jsx as _jsx } from "react/jsx-runtime";
import moment from 'moment-timezone';
import { usePromoCodeFormContext } from './use-promo-code-form';
import { AddNewPromoCodeContent } from './add-new-promo-code-content';
import { getTimezone, useSession } from '../../../../../../infra/session';
export var AddNewPromoCodeContentContainer = function (_a) {
    var isLoading = _a.isLoading;
    var _b = usePromoCodeFormContext(), control = _b.control, watch = _b.watch, errors = _b.formState.errors;
    var selectedType = watch('kind');
    var session = useSession().data;
    var timezone = getTimezone(session);
    var minDate = moment().add(1, 'days').tz(timezone).toDate();
    return (_jsx(AddNewPromoCodeContent, { control: control, selectedType: selectedType, errors: errors, isLoading: isLoading, minDate: minDate }));
};
